import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const wrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
`
export const iconWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const icon = css`
  height: ${37 * unit}px;
  width: ${37 * unit}px;
  ${MQ.PHONES} {
    height: ${20 * unit}px;
    width: ${20 * unit}px;
  }
`

export const wrapText = css`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const wrapperRow = css`
  width: 100%;
`
